<script setup>
const loading = defineModel('loading')
const props = defineProps({
  title: {
    type: String,
    default: 'Cargando...'
  }
})
</script>

<template>
  <Transition>
    <div v-show="loading" class="col-span-12">
      <i class="pi pi-spin pi-spinner" style="font-size: 1rem"/>
      <span class="ml-2">{{ props.title }}</span>
    </div>
  </Transition>
</template>
